<template>
  <div class="expandable-list-section">
    <expandable-list-paragraph
      v-for="paragraph of paragraphs"
      :key="paragraph.title"
      class="expandable-list-section__paragraph"
      :paragraph="paragraph"
    />
  </div>
</template>

<script>
/* eslint-disable */
import ExpandableListParagraph from '@/components/discover/ExpandableListParagraph.vue';

import { PRODUCT_NAMES } from '@/constants/treatment';

import { TextParagraph } from '@/models/discover/TextParagraph';

const HOW_TO_USE_PARAGRAPHS = {
  [PRODUCT_NAMES.FACE_SERUM]: new TextParagraph({
    body: 'discover.product.serum.face.expandableList.howToUse.body'
  }),
  [PRODUCT_NAMES.EYE_CONTOUR_SERUM]: new TextParagraph({
    body: 'discover.product.serum.eye.expandableList.howToUse.body'
  }),
  [PRODUCT_NAMES.UNIVERSKIN_H]: new TextParagraph({
    title: 'discover.product.universkinH.expandableList.howToUse.title',
    body: 'discover.product.universkinH.expandableList.howToUse.body'
  }),
  [PRODUCT_NAMES.NEXULTRA_O]: [
    new TextParagraph({
      title: 'discover.product.nexultraO.expandableList.howToUse.subtitle.face',
      body: 'discover.product.nexultraO.expandableList.howToUse.body.face'
    }),
    new TextParagraph({
      title: 'discover.product.nexultraO.expandableList.howToUse.subtitle.eyes',
      body: 'discover.product.nexultraO.expandableList.howToUse.body.eyes'
    }),
    new TextParagraph({
      title: 'discover.product.nexultraO.expandableList.howToUse.subtitle.hairScalp',
      body: 'discover.product.nexultraO.expandableList.howToUse.body.hairScalp'
    })
  ],
  [PRODUCT_NAMES.NEXULTRA_1]: new TextParagraph({
    body: 'discover.product.nexultra1.expandableList.howToUse.body'
  }),
  [PRODUCT_NAMES.NEXULTRA_2]: new TextParagraph({
    body: 'discover.product.nexultra2.expandableList.howToUse.body'
  }),
  [PRODUCT_NAMES.NEXULTRA_3]: new TextParagraph({
    body: 'discover.product.nexultra3.expandableList.howToUse.body'
  }),
  [PRODUCT_NAMES.NEXULTRA_L]: new TextParagraph({
    body: 'discover.product.nexultraL.expandableList.howToUse.body'
  }),
  [PRODUCT_NAMES.NEXULTRA_B]: new TextParagraph({
    body: 'discover.product.nexultraB.expandableList.howToUse.body'
  }),
  [PRODUCT_NAMES.GEL]: new TextParagraph({
    body: 'discover.product.gel.expandableList.howToUse.body'
  }),
  [PRODUCT_NAMES.SUNSCREEN_FLD]: new TextParagraph({
    body: 'discover.product.sunscreenFluidSpf50.expandableList.howToUse.body'
  }),
  [PRODUCT_NAMES.SUNSCREEN_SPF]: new TextParagraph({
    body: 'discover.product.sunscreenSPF.expandableList.howToUse.body'
  }),
  [PRODUCT_NAMES.SUNSCREEN_CRM]: new TextParagraph({
    body: 'discover.product.sunscreenCRM.expandableList.howToUse.body'
  }),
  [PRODUCT_NAMES.NEXULTRA_UV]: new TextParagraph({
    body: 'discover.product.nexultraUV.expandableList.howToUse.body'
  }),
  [PRODUCT_NAMES.NEXULTRA_P_LIGHT]: new TextParagraph({
    body: 'discover.product.nexultraPLight.expandableList.howToUse.body'
  }),
  [PRODUCT_NAMES.NEXULTRA_P_RICH]: new TextParagraph({
    body: 'discover.product.nexultraPRich.expandableList.howToUse.body'
  }),
  [PRODUCT_NAMES.UNIVERSKIN_M]: new TextParagraph({
    body: 'discover.product.universkinM.expandableList.howToUse.body'
  })
};

export default {
  name: 'HowToUseSection',
  components: { ExpandableListParagraph },
  props: {
    productName: {
      type: String,
      required: true
    }
  },
  computed: {
    paragraphs() {
      const paragraphs = HOW_TO_USE_PARAGRAPHS[this.productName];
      return Array.isArray(paragraphs) ? paragraphs : [paragraphs];
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/expandable-list.scss';
</style>
